<template>
  <TrendView ref="trendview" :measurePoints="measurePoints" @on-close="closeTrendDialog">
  </TrendView>
</template>

<script>
import TrendView from '@/modules/visualization-cockpit/components/business/SisSystem/TrendView/index'
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  components: { TrendView },
  props: {
    measurePoints: {
      type: Array,
    },
  },
  data() {
    return {}
  },
  methods: {
    closeTrendDialog() {
      this.$emit('closeTrendDialog')
    },
  },
}
</script>

<style lang="scss" scoped></style>
